/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ path: NonNullable<unknown> }} Chat_Space_File_New_PathInputs */



/**
* | output |
* | --- |
* | "New path: {path}" |
*
* @param {Chat_Space_File_New_PathInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_new_path = /** @type {((inputs: Chat_Space_File_New_PathInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_New_PathInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Neuer Pfad: ${i?.path}`)
	return /** @type {LocalizedString} */ (`New path: ${i?.path}`)
});